import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=c4657d1e&scoped=true&"
import script from "./Course.vue?vue&type=script&lang=js&"
export * from "./Course.vue?vue&type=script&lang=js&"
import style0 from "./Course.vue?vue&type=style&index=0&id=c4657d1e&lang=less&scoped=true&"
import style1 from "./Course.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4657d1e",
  null
  
)

export default component.exports